module.exports = __webpack_public_path__ + "static/media/MEDA.067ef868.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/MEDA.jpg
// module id = 1565
// module chunks = 1